


















































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ReviewList from "../components/reviews/review-list.vue";

export default Vue.extend({
  components: {
    ReviewList,
  },
  data() {
    return {
      isCollapsed: false,
      personalReviewFilter: "All Reviews",
      selectedMemberId: NaN,
      showFilterPoptip: false,
      accountId: window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("review", ["loading"]),
    ...mapGetters("review", ["canAdd"]),
    ...mapState("session", ["user", "billingAccountIdChangedCount", "billingAccounts"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["hasAccountAdminPermission", "hasUserManagementPermission"]),
    billingAccountId: {
      get() {
        return (this as any).accountId;
      },
      set(newValue) {
        this.accountId = newValue;
        this.$store.dispatch("session/setCurrentBillingAccountId", newValue);
      },
    },
    currentBillingAccount() {
      let accounts = (this as any).billingAccounts.filter((a) => a.id == (this as any).billingAccountId);
      return accounts.length > 0 ? accounts[0] : null;
    },
    hashTags() {
      let hashTags = ["All Reviews", "Active Reviews", "Completed Reviews"];
      let allReviews = this.$store.state.review.myReviews || [];
      allReviews.forEach((review) => {
        hashTags = hashTags.concat(review.hashTagList.map((tag) => "#" + tag.text));
      });
      return [...new Set(hashTags)];
    },
    members() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.members : [];
    },
  },
  watch: {
    billingAccountIdChangedCount(newVal) {
      this.$store.dispatch("review/getMyReviews", {});
    },
    user(newVal) {
      let context = this as any;
      if (newVal) {
        context.selectedMemberId = newVal.id;

        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  created() {
    (this as any).$store.dispatch("review/setReviewExclusionFilter", "none");
    this.$store.dispatch("review/getMyReviews", {});
  },
  mounted() {
    let context = this as any;
    if (context.user) {
      context.selectedMemberId = context.user.id;
    }
  },
  methods: {
    handleAddReview() {
      (this.$refs.ReviewList as any).showReviewCreator();
    },
    getUserTitle(user) {
      let roleName = "User";
      switch (user.role) {
        case 1:
          roleName = "Admin";
          break;
        case 2:
          roleName = "Manager";
          break;
        case 3:
          roleName = "User";
          break;
        default:
          roleName = "User";
          break;
      }

      //return `${user.memberName} - ${roleName}`;
      return `${user.memberName}`;
    },
  },
});
